<main>
  <GoogleAnalytics properties={['G-C85WBNSL7Z']} />
  {#if initialised}
    {#if !dbConnectionFailure}
      <slot />
    {:else}
      <Disconnected />
    {/if}
  {/if}
</main>

<script lang="ts">
  import { appState } from '$lib/appState';
  import { brand, SPORT_BRAND_CLASS } from '$lib/brand';
  import '$lib/styles/main.scss';
  import { GoogleAnalytics } from '@beyonk/svelte-google-analytics';
  import Disconnected from '$lib/components/Disconnected.svelte';
  import { logging } from '$lib/logging';

  import firebase from 'firebase/compat/app';
  import 'firebase/compat/auth';
  import 'firebase/compat/performance';
  import 'firebase/compat/analytics';
  import 'firebase/compat/functions';
  import 'firebase/compat/storage';
  import { getApp } from 'firebase/app';
  import { doc, getDoc } from 'firebase/firestore';
  import { initDb, getDb } from '$lib/db';

  let initialised = false;
  let dbConnectionFailure = false;

  fetch('/__/firebase/init.json')
    .then(async (response) => {
      const firebaseInitParams = await response.json();

      const databaseId = 'default-enterprise';

      firebase.initializeApp(firebaseInitParams);
      initDb(getApp(), databaseId);

      logging.start({
        key: firebaseInitParams.apiKey,
        projectId: firebaseInitParams.projectId
      });

      initialised = true;
    })
    .then(() => {
      getDoc(doc(getDb(), '_config', 'test'))
        .then(() => {
          // no action
        })
        .catch(() => {
          dbConnectionFailure = true;
          logging.report('No connection to firestore');
        });
    });

  window.firebase = firebase;

  $appState.origin = window.location.origin;

  // The sub-brand is a class on <html> rather than a wrapper element, so it
  // covers anything portalled outside <main> too. SSR is off (+layout.ts), so
  // document is always there.
  $: document.documentElement.classList.toggle(
    SPORT_BRAND_CLASS,
    $brand === 'sport'
  );
</script>
